import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import { useBatchApproveAllowancePreviewContext } from "src/views/AssetManagement/BatchApproveAllowance/contexts";
import {
  areAllAddressesSelected,
  setAllAddressesSelectionByWalletMajorVersion,
} from "./helpers/selectionHelpers";
import { TABLE_COLUMNS } from "./constants/tableColumns";
import OverflowTooltipText from "src/components/OverflowTooltipText";

function TableHeader() {
  const {
    sendingAddressesMap,
    setSendingAddressesMap,
    translate: t,
    walletMajorVersion,
  } = useBatchApproveAllowancePreviewContext();

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSendingAddressesMap((prev) =>
      setAllAddressesSelectionByWalletMajorVersion(
        prev,
        event.target.checked,
        walletMajorVersion,
      ),
    );
  };

  return (
    <TableHead sx={{ background: "#fff" }}>
      <TableRow>
        {TABLE_COLUMNS.map((column) => (
          <TableCell key={column.id} sx={{ color: "#a2a2a2" }} align={"center"}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <OverflowTooltipText text={t(column.labelKey)} />
              {column.id === "select_all" && (
                <Checkbox
                  checked={areAllAddressesSelected(
                    sendingAddressesMap,
                    walletMajorVersion,
                  )}
                  onChange={handleSelectAll}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default TableHeader;
